import { createApiClient } from '../../api';
import type { SiteAccess } from '../types';

import { ACCESS_ENDPOINTS } from './endpoints';
import { errorFrom } from './http';
import { parseSiteAccess } from './schemas';

const { request } = createApiClient({ toError: errorFrom });

export const fetchSiteAccess = async (plantIds: readonly string[], signal: AbortSignal | undefined): Promise<readonly SiteAccess[]> =>
  parseSiteAccess(await request('get', ACCESS_ENDPOINTS.SITE_ACCESS, { params: { plantIds: plantIds.join(',') }, signal })).plants;
